(() => {
  /* Bouton mobile unique : ouvre le sélecteur global pays + langue. */
  if (!window.__kolorsHeaderLocaleButtonBound) {
    window.__kolorsHeaderLocaleButtonBound = true;

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-kh-global-locale-open]');
      if (!button) return;

      const globalTrigger = document.querySelector(
        '[data-kgl-root] .kgl__trigger, [data-kgl-root] [data-kgl-open]'
      );

      if (globalTrigger) {
        event.preventDefault();
        globalTrigger.click();
      }
    });
  }

  const initializeKolorsHeader = (root) => {
    if (!root || root.dataset.khReady === "true") return;

    root.dataset.khReady = "true";

    /* Interface copy follows the active Shopify language. */
    const interfaceTranslations = {
      en: {
        "Message précédent": "Previous message",
        "Message suivant": "Next message",
        "–15 % dès 3 tableaux": "15% off 3+ artworks",
        "Offre appliquée automatiquement": "Discount applied automatically",
        "Livraison gratuite dès 50 €": "Free delivery over 50 €",
        "Rapide, suivie et sécurisée": "Fast, tracked and secure",
        "Livraison rapide & suivie": "Fast, tracked delivery",
        "Suivez votre commande à chaque étape": "Track your order at every step",
        "Créé par un Marocain": "Founded by a Moroccan",
        "Pour ceux qui portent le Maroc en eux": "For those who carry Morocco with them",
        "Ouvrir le menu": "Open menu",
        "Fermer le menu": "Close menu",
        "KOLORS — Accueil": "KOLORS — Home",
        "Navigation principale": "Main navigation",
        "Découvrir": "Shop all",
        "Nos tableaux": "Shop artwork",
        "TROUVEZ VOTRE ŒUVRE": "FIND YOUR ARTWORK",
        "Des tableaux qui racontent quelque chose.": "Art that tells a story.",
        "Explorez nos essentiels, des créations marocaines aux compositions murales.": "Explore our essentials, from Moroccan artwork to curated gallery walls.",
        "Packs de tableaux": "Art sets",
        "L’ESSENTIEL KOLORS": "KOLORS ESSENTIALS",
        "L’ESSENTIEL": "ESSENTIALS",
        "Découvrir →": "Explore →",
        "FINITION GALERIE": "GALLERY FINISH",
        "POUR HABILLER UN MUR": "MADE FOR YOUR WALL",
        "Compositions murales": "Gallery walls",
        "Murs de cadres": "Gallery walls",
        "Avis clients": "Customer reviews",
        "Collections": "Collections",
        "Nouveautés": "New arrivals",
        "Top ventes": "Best sellers",
        "Packs": "Art sets",
        "Tout voir": "View all",
        "À propos": "About us",
        "Aide": "Help",
        "BESOIN D’UN COUP DE MAIN ?": "NEED A HAND?",
        "Questions fréquentes": "Frequently asked questions",
        "Les réponses essentielles": "Everything you need to know",
        "Livraison": "Shipping",
        "Délais, fabrication et expédition": "Production and delivery times",
        "Suivre ma commande": "Track my order",
        "Consulter son avancement": "Check your order status",
        "Retours & remboursements": "Returns & refunds",
        "Consulter nos conditions": "Read our policy",
        "Nous contacter": "Contact us",
        "Une équipe à votre écoute": "Our team is here to help",
        "Rechercher": "Search",
        "Choisir votre pays ou région": "Choose your store or region",
        "🇪🇺 Europe · EUR": "🇪🇺 Europe · EUR",
        "Panier": "Cart",
        "LE MAROC": "MOROCCO",
        "Tout l’art marocain": "All Moroccan art",
        "Souvenirs d’enfance": "Moroccan childhood",
        "Villes du Maroc": "Moroccan cities",
        "NOS UNIVERS": "SHOP BY STYLE",
        "Photos encadrées": "Framed prints",
        "NOUVEAUTÉ": "NEW",
        "Art islamique": "Islamic art",
        "Déco moderne": "Modern wall art",
        "Art abstrait": "Abstract art",
        "Coupe du monde": "World Cup",
        "Packs & compositions": "Art sets & compositions",
        "Composition murale": "Gallery walls",
        "À DÉCOUVRIR": "DISCOVER",
        "Meilleures ventes": "Best sellers",
        "Nos packs": "Our art sets",
        "Toutes les créations": "All artwork",
        "À propos de KOLORS": "About KOLORS",
        "Notre histoire": "Our story",
        "NOUVELLE FINITION": "NEW FINISH",
        "L’art marocain.": "Moroccan art.",
        "Encadré comme en galerie.": "Framed like a gallery piece.",
        "Découvrir les photos encadrées": "Discover framed prints",
        "DÉCOUVRIR KOLORS": "DISCOVER KOLORS",
        "VOS INTÉRIEURS, VOS HISTOIRES": "YOUR HOMES, YOUR STORIES",
        "NOUVEAU": "NEW",
        "LES PLUS AIMÉS": "MOST LOVED",
        "COMPOSITIONS": "ART SETS",
        "EXPLORER": "EXPLORE",
        "Tous les tableaux": "All artwork",
        "Univers marocains": "Moroccan collections",
        "Autres univers": "More collections",
        "Aide & informations": "Help & information",
        "FAQ": "FAQ",
        "Suivi": "Tracking",
        "Contact": "Contact",
        "Pays / Région": "Country / Region",
        "Langue · FR": "Language · FR",
        "Langue · EN": "Language · EN",
        "Langue · DE": "Language · DE",
        "Besoin d’aide ?": "Need help?",
        "Fermer la recherche": "Close search",
        "RECHERCHER SUR KOLORS": "SEARCH KOLORS",
        "Fermer": "Close",
        "Que recherchez-vous ?": "What are you looking for?",
        "Une ville, un souvenir, une collection…": "A city, a memory, a collection…",
        "RECHERCHES POPULAIRES": "POPULAR SEARCHES",
        "Fermer le sélecteur de pays": "Close country selector",
        "VOTRE BOUTIQUE": "YOUR STORE",
        "Choisissez votre boutique": "Choose your store",
        "Accédez à la boutique KOLORS et à la devise adaptées à votre région.": "Shop KOLORS in the store and currency for your region.",
        "Europe": "Europe",
        "EUR · FR / EN / DE": "EUR · FR / EN / DE",
        "États-Unis": "United States",
        "Maroc": "Morocco"
      },
      de: {
        "Message précédent": "Vorherige Nachricht",
        "Message suivant": "Nächste Nachricht",
        "–15 % dès 3 tableaux": "15 % Rabatt ab 3 Bildern",
        "Offre appliquée automatiquement": "Rabatt wird automatisch angewendet",
        "Livraison gratuite dès 50 €": "Kostenloser Versand ab 50 €",
        "Rapide, suivie et sécurisée": "Schnell, sicher und mit Sendungsverfolgung",
        "Livraison rapide & suivie": "Schnelle Lieferung mit Sendungsverfolgung",
        "Suivez votre commande à chaque étape": "Verfolgen Sie Ihre Bestellung jederzeit",
        "Créé par un Marocain": "Von einem Marokkaner gegründet",
        "Pour ceux qui portent le Maroc en eux": "Für alle, die Marokko im Herzen tragen",
        "Ouvrir le menu": "Menü öffnen",
        "Fermer le menu": "Menü schließen",
        "KOLORS — Accueil": "KOLORS — Startseite",
        "Navigation principale": "Hauptnavigation",
        "Découvrir": "Alle entdecken",
        "Nos tableaux": "Kunst entdecken",
        "TROUVEZ VOTRE ŒUVRE": "FINDEN SIE IHR KUNSTWERK",
        "Des tableaux qui racontent quelque chose.": "Kunstwerke, die eine Geschichte erzählen.",
        "Explorez nos essentiels, des créations marocaines aux compositions murales.": "Entdecken Sie unsere Highlights – von marokkanischer Kunst bis zu kuratierten Bilderwänden.",
        "Packs de tableaux": "Kunst-Sets",
        "L’ESSENTIEL KOLORS": "KOLORS ESSENTIALS",
        "L’ESSENTIEL": "ESSENTIALS",
        "Découvrir →": "Entdecken →",
        "FINITION GALERIE": "GALERIE-FINISH",
        "POUR HABILLER UN MUR": "FÜR IHRE WAND",
        "Compositions murales": "Bilderwände",
        "Murs de cadres": "Bilderwände",
        "Avis clients": "Kundenbewertungen",
        "Collections": "Kollektionen",
        "Nouveautés": "Neuheiten",
        "Top ventes": "Bestseller",
        "Packs": "Kunst-Sets",
        "Tout voir": "Alle ansehen",
        "À propos": "Über uns",
        "Aide": "Hilfe",
        "BESOIN D’UN COUP DE MAIN ?": "BRAUCHEN SIE HILFE?",
        "Questions fréquentes": "Häufig gestellte Fragen",
        "Les réponses essentielles": "Die wichtigsten Antworten",
        "Livraison": "Versand",
        "Délais, fabrication et expédition": "Produktions- und Lieferzeiten",
        "Suivre ma commande": "Bestellung verfolgen",
        "Consulter son avancement": "Bestellstatus ansehen",
        "Retours & remboursements": "Rückgabe & Erstattung",
        "Consulter nos conditions": "Bedingungen ansehen",
        "Nous contacter": "Kontakt",
        "Une équipe à votre écoute": "Unser Team hilft Ihnen gerne",
        "Rechercher": "Suchen",
        "Choisir votre pays ou région": "Shop oder Region auswählen",
        "🇪🇺 Europe · EUR": "🇪🇺 Europa · EUR",
        "Panier": "Warenkorb",
        "LE MAROC": "MAROKKO",
        "Tout l’art marocain": "Alle marokkanischen Kunstwerke",
        "Souvenirs d’enfance": "Marokkanische Kindheit",
        "Villes du Maroc": "Marokkanische Städte",
        "NOS UNIVERS": "NACH STIL ENTDECKEN",
        "Photos encadrées": "Gerahmte Drucke",
        "NOUVEAUTÉ": "NEU",
        "Art islamique": "Islamische Kunst",
        "Déco moderne": "Moderne Wandkunst",
        "Art abstrait": "Abstrakte Kunst",
        "Coupe du monde": "Weltmeisterschaft",
        "Packs & compositions": "Kunst-Sets & Kompositionen",
        "Composition murale": "Bilderwände",
        "À DÉCOUVRIR": "ENTDECKEN",
        "Meilleures ventes": "Bestseller",
        "Nos packs": "Unsere Kunst-Sets",
        "Toutes les créations": "Alle Kunstwerke",
        "À propos de KOLORS": "Über KOLORS",
        "Notre histoire": "Unsere Geschichte",
        "NOUVELLE FINITION": "NEUES FINISH",
        "L’art marocain.": "Marokkanische Kunst.",
        "Encadré comme en galerie.": "Gerahmt wie in einer Galerie.",
        "Découvrir les photos encadrées": "Gerahmte Drucke entdecken",
        "DÉCOUVRIR KOLORS": "KOLORS ENTDECKEN",
        "VOS INTÉRIEURS, VOS HISTOIRES": "IHR ZUHAUSE, IHRE GESCHICHTEN",
        "NOUVEAU": "NEU",
        "LES PLUS AIMÉS": "BELIEBTESTE",
        "COMPOSITIONS": "KUNST-SETS",
        "EXPLORER": "ENTDECKEN",
        "Tous les tableaux": "Alle Kunstwerke",
        "Univers marocains": "Marokkanische Kollektionen",
        "Autres univers": "Weitere Kollektionen",
        "Aide & informations": "Hilfe & Informationen",
        "FAQ": "FAQ",
        "Suivi": "Sendungsverfolgung",
        "Contact": "Kontakt",
        "Pays / Région": "Land / Region",
        "Langue · FR": "Sprache · FR",
        "Langue · EN": "Sprache · EN",
        "Langue · DE": "Sprache · DE",
        "Besoin d’aide ?": "Brauchen Sie Hilfe?",
        "Fermer la recherche": "Suche schließen",
        "RECHERCHER SUR KOLORS": "KOLORS DURCHSUCHEN",
        "Fermer": "Schließen",
        "Que recherchez-vous ?": "Wonach suchen Sie?",
        "Une ville, un souvenir, une collection…": "Eine Stadt, eine Erinnerung, eine Kollektion…",
        "RECHERCHES POPULAIRES": "BELIEBTE SUCHANFRAGEN",
        "Fermer le sélecteur de pays": "Länderauswahl schließen",
        "VOTRE BOUTIQUE": "IHR SHOP",
        "Choisissez votre boutique": "Shop auswählen",
        "Europe": "Europa",
        "EUR · FR / EN / DE": "EUR · FR / EN / DE",
        "Accédez à la boutique KOLORS et à la devise adaptées à votre région.": "Nutzen Sie den KOLORS Shop und die Währung für Ihre Region.",
        "États-Unis": "Vereinigte Staaten",
        "Maroc": "Marokko"
      }
    };

    const translateInterface = () => {
      const language = (root.dataset.khLanguage || "fr").slice(0, 2);
      const dictionary = interfaceTranslations[language];
      if (!dictionary) return;

      const walker = document.createTreeWalker(
        root,
        NodeFilter.SHOW_TEXT
      );
      const nodes = [];

      while (walker.nextNode()) nodes.push(walker.currentNode);

      nodes.forEach((node) => {
        const value = node.nodeValue;
        const key = value.replace(/\s+/g, " ").trim();
        if (!key || !dictionary[key]) return;

        const leading = value.match(/^\s*/)?.[0] || "";
        const trailing = value.match(/\s*$/)?.[0] || "";
        node.nodeValue = `${leading}${dictionary[key]}${trailing}`;
      });

      root.querySelectorAll("[aria-label], [placeholder]").forEach((element) => {
        ["aria-label", "placeholder"].forEach((attribute) => {
          const value = element.getAttribute(attribute);
          if (value && dictionary[value]) {
            element.setAttribute(attribute, dictionary[value]);
          }
        });
      });
    };

    translateInterface();

    const header = root.querySelector("[data-kh-header]");
    const isHome = root.dataset.khHome === "true";

    document.body.classList.toggle(
      "kh-home-page",
      isHome
    );

    document.body.classList.toggle(
      "kh-internal-page",
      !isHome
    );

    const announcementMessages = Array.from(
      root.querySelectorAll("[data-kh-announcement-message]")
    );

    const announcementPrevious = root.querySelector(
      "[data-kh-announcement-prev]"
    );

    const announcementNext = root.querySelector(
      "[data-kh-announcement-next]"
    );

    const announcementProgress = root.querySelector(
      "[data-kh-announcement-progress]"
    );

    const megaTriggers = Array.from(
      root.querySelectorAll("[data-kh-mega-trigger]")
    );

    const megaZones = Array.from(
      root.querySelectorAll("[data-kh-mega-zone]")
    );

    const megaMenus = Array.from(
      root.querySelectorAll("[data-kh-mega]")
    );

    const help = root.querySelector("[data-kh-help]");

    const helpTrigger = root.querySelector(
      "[data-kh-help-trigger]"
    );

    const drawer = root.querySelector("[data-kh-drawer]");

    const drawerOpen = root.querySelector(
      "[data-kh-drawer-open]"
    );

    const drawerCloseButtons = root.querySelectorAll(
      "[data-kh-drawer-close]"
    );

    const search = root.querySelector("[data-kh-search]");

    const searchOpenButtons = root.querySelectorAll(
      "[data-kh-search-open]"
    );

    const searchCloseButtons = root.querySelectorAll(
      "[data-kh-search-close]"
    );

    const searchInput = root.querySelector(
      "[data-kh-search-input]"
    );

    const country = root.querySelector("[data-kh-country]");
    const countryOpenButtons = Array.from(
      root.querySelectorAll("[data-kh-country-open]")
    );
    const countryCloseButtons = Array.from(
      root.querySelectorAll("[data-kh-country-close]")
    );
    const countryInput = root.querySelector(
      "[data-kh-country-input]"
    );
    const countryOptions = Array.from(
      root.querySelectorAll("[data-kh-country-value]")
    );
    const language = root.querySelector(
      "[data-kh-language-selector]"
    );
    const languageOpenButtons = Array.from(
      root.querySelectorAll("[data-kh-language-open]")
    );
    const languageCloseButtons = Array.from(
      root.querySelectorAll("[data-kh-language-close]")
    );
    const languageInput = root.querySelector(
      "[data-kh-language-input]"
    );
    const languageOptions = Array.from(
      root.querySelectorAll("[data-kh-language-value]")
    );
    const accordionTriggers = Array.from(
      root.querySelectorAll("[data-kh-accordion-trigger]")
    );

    const cartCounter = root.querySelector(
      "[data-kh-cart-count]"
    );

    let announcementIndex = 0;
    let announcementTimer = null;
    let progressAnimation = null;

    let megaCloseTimer = null;
    let helpCloseTimer = null;
    let previousFocus = null;

    [drawer, search, country, language].forEach((overlay) => {
      if (overlay) document.body.appendChild(overlay);
    });

    /* =====================================================
       HEADER AU SCROLL
    ====================================================== */

    const updateHeader = () => {
      if (!header) return;

      header.classList.toggle(
        "is-scrolled",
        window.scrollY > 16
      );

      if (!isHome) {
        header.classList.add("is-solid");
      }
    };

    window.addEventListener("scroll", updateHeader, {
      passive: true
    });

    updateHeader();

    /* =====================================================
       BARRE D’ANNONCE
    ====================================================== */

    const animateProgress = () => {
      if (!announcementProgress) return;

      if (progressAnimation) {
        progressAnimation.cancel();
      }

      announcementProgress.style.width = "0%";

      progressAnimation = announcementProgress.animate(
        [
          { width: "0%" },
          { width: "100%" }
        ],
        {
          duration: 4200,
          easing: "linear",
          fill: "forwards"
        }
      );
    };

    const showAnnouncement = (index) => {
      if (!announcementMessages.length) return;

      announcementIndex =
        (index + announcementMessages.length) %
        announcementMessages.length;

      announcementMessages.forEach(
        (message, messageIndex) => {
          message.classList.toggle(
            "is-active",
            messageIndex === announcementIndex
          );
        }
      );

      animateProgress();
    };

    const restartAnnouncementTimer = () => {
      window.clearInterval(announcementTimer);

      if (announcementMessages.length <= 1) return;

      announcementTimer = window.setInterval(() => {
        showAnnouncement(announcementIndex + 1);
      }, 4200);
    };

    announcementPrevious?.addEventListener("click", () => {
      showAnnouncement(announcementIndex - 1);
      restartAnnouncementTimer();
    });

    announcementNext?.addEventListener("click", () => {
      showAnnouncement(announcementIndex + 1);
      restartAnnouncementTimer();
    });

    showAnnouncement(0);
    restartAnnouncementTimer();

    /* =====================================================
       MENU AIDE
    ====================================================== */

    function closeHelp() {
      if (!help || !helpTrigger) return;

      help.classList.remove("is-open");

      helpTrigger.setAttribute(
        "aria-expanded",
        "false"
      );
    }

    function openHelp() {
      if (!help || !helpTrigger) return;

      closeMega();

      window.clearTimeout(helpCloseTimer);

      help.classList.add("is-open");

      helpTrigger.setAttribute(
        "aria-expanded",
        "true"
      );
    }

    const scheduleHelpClose = () => {
      window.clearTimeout(helpCloseTimer);

      helpCloseTimer = window.setTimeout(() => {
        closeHelp();
      }, 380);
    };

    helpTrigger?.addEventListener("click", () => {
      if (help?.classList.contains("is-open")) {
        closeHelp();
      } else {
        openHelp();
      }
    });

    help?.addEventListener("mouseenter", () => {
      window.clearTimeout(helpCloseTimer);
    });

    help?.addEventListener(
      "mouseleave",
      scheduleHelpClose
    );

    /* =====================================================
       MEGA MENU COLLECTIONS
    ====================================================== */

    function closeMega(exceptId = null) {
      megaMenus.forEach((menu) => {
        if (exceptId && menu.dataset.khMega === exceptId) return;
        menu.classList.remove("is-open");
      });

      megaTriggers.forEach((trigger) => {
        if (exceptId && trigger.dataset.khMegaTrigger === exceptId) return;
        trigger.setAttribute("aria-expanded", "false");
      });

      if (!exceptId) header?.classList.remove("is-mega-open");
    }

    function openMega(id) {
      const menu = megaMenus.find(
        (item) => item.dataset.khMega === id
      );
      const trigger = megaTriggers.find(
        (item) => item.dataset.khMegaTrigger === id
      );

      if (!menu || !trigger) return;

      closeHelp();
      window.clearTimeout(megaCloseTimer);
      closeMega(id);

      menu.classList.add("is-open");
      header?.classList.add("is-mega-open");
      trigger.setAttribute("aria-expanded", "true");
    }

    const scheduleMegaClose = () => {
      window.clearTimeout(megaCloseTimer);

      megaCloseTimer = window.setTimeout(() => {
        closeMega();
      }, 380);
    };

    megaTriggers.forEach((trigger) => {
      trigger.addEventListener("click", () => {
        const id = trigger.dataset.khMegaTrigger;
        const menu = megaMenus.find(
          (item) => item.dataset.khMega === id
        );

        if (menu?.classList.contains("is-open")) closeMega();
        else openMega(id);
      });
    });

    megaZones.forEach((zone) => {
      const id = zone.dataset.khMegaZone;
      zone.addEventListener("mouseenter", () => {
        window.clearTimeout(megaCloseTimer);
        openMega(id);
      });
      zone.addEventListener("mouseleave", scheduleMegaClose);
    });

    megaMenus.forEach((menu) => {
      menu.addEventListener("mouseenter", () => {
        window.clearTimeout(megaCloseTimer);
        openMega(menu.dataset.khMega);
      });
      menu.addEventListener("mouseleave", scheduleMegaClose);
    });

    /* =====================================================
       CLIC À L’EXTÉRIEUR
    ====================================================== */

    document.addEventListener("click", (event) => {
      if (
        !event.target.closest("[data-kh-mega]") &&
        !event.target.closest("[data-kh-mega-trigger]")
      ) {
        closeMega();
      }

      if (!event.target.closest("[data-kh-help]")) {
        closeHelp();
      }
    });

    /* =====================================================
       VERROUILLAGE PAGE
    ====================================================== */

    const lockPage = () => {
      document.documentElement.classList.add("kh-lock");
      document.body.classList.add("kh-lock");
      header?.classList.add("is-overlay-open");
    };

    const unlockPage = () => {
      const overlayOpen =
        drawer?.classList.contains("is-open") ||
        search?.classList.contains("is-open") ||
        country?.classList.contains("is-open") ||
        language?.classList.contains("is-open");

      if (!overlayOpen) {
        document.documentElement.classList.remove("kh-lock");
        document.body.classList.remove("kh-lock");
        header?.classList.remove("is-overlay-open");
      }
    };

    /* =====================================================
       DRAWER MOBILE
    ====================================================== */

    const closeDrawer = () => {
      if (!drawer) return;

      drawer.classList.remove("is-open");
      drawer.setAttribute("aria-hidden", "true");

      drawerOpen?.setAttribute(
        "aria-expanded",
        "false"
      );

      unlockPage();
    };

    const openDrawer = () => {
      if (!drawer) return;

      closeMega();
      closeHelp();
      closeSearch();
      closeCountry();
      closeLanguage();

      drawer.classList.add("is-open");
      drawer.setAttribute("aria-hidden", "false");

      drawerOpen?.setAttribute(
        "aria-expanded",
        "true"
      );

      lockPage();
    };

    drawerOpen?.addEventListener("click", openDrawer);

    drawerCloseButtons.forEach((button) => {
      button.addEventListener("click", closeDrawer);
    });

    /* =====================================================
       ACCORDÉONS MOBILE
    ====================================================== */

    accordionTriggers.forEach((trigger) => {
        trigger.addEventListener("click", () => {
          const accordion = trigger.closest(
            ".kh-drawer__accordion"
          );

          if (!accordion) return;

          const isOpen =
            accordion.classList.contains("is-open");

          accordion.classList.toggle(
            "is-open",
            !isOpen
          );

          trigger.setAttribute(
            "aria-expanded",
            String(!isOpen)
          );
        });
    });

    /* =====================================================
       RECHERCHE
    ====================================================== */

    function closeSearch() {
      if (!search) return;

      search.classList.remove("is-open");
      search.setAttribute("aria-hidden", "true");

      unlockPage();
    }

    function openSearch() {
      if (!search) return;

      closeMega();
      closeHelp();
      closeDrawer();
      closeCountry();
      closeLanguage();

      search.classList.add("is-open");
      search.setAttribute("aria-hidden", "false");

      lockPage();

      window.setTimeout(() => {
        searchInput?.focus();
      }, 180);
    }

    searchOpenButtons.forEach((button) => {
      button.addEventListener("click", openSearch);
    });

    searchCloseButtons.forEach((button) => {
      button.addEventListener("click", closeSearch);
    });

    /* =====================================================
       PAYS / RÉGION
    ====================================================== */

    function closeCountry() {
      if (!country) return;

      country.classList.remove("is-open");
      country.setAttribute("aria-hidden", "true");

      countryOpenButtons.forEach((button) => {
        button.setAttribute("aria-expanded", "false");
      });

      unlockPage();
    }

    function openCountry(event) {
      if (!country) return;

      previousFocus = event?.currentTarget || document.activeElement;

      closeMega();
      closeHelp();
      closeDrawer();
      closeSearch();
      closeLanguage();

      country.classList.add("is-open");
      country.setAttribute("aria-hidden", "false");

      countryOpenButtons.forEach((button) => {
        button.setAttribute("aria-expanded", "true");
      });

      lockPage();

      window.setTimeout(() => {
        country.querySelector("[data-kh-country-close]")?.focus();
      }, 120);
    }

    countryOpenButtons.forEach((button) => {
      button.addEventListener("click", openCountry);
    });

    countryCloseButtons.forEach((button) => {
      button.addEventListener("click", () => {
        closeCountry();
        previousFocus?.focus?.({ preventScroll: true });
      });
    });

    countryOptions.forEach((button) => {
      button.addEventListener("click", () => {
        if (!countryInput) return;

        countryInput.value = button.dataset.khCountryValue;
        countryInput.closest("form")?.submit();
      });
    });

    /* =====================================================
       LANGUE
    ====================================================== */

    function closeLanguage() {
      if (!language) return;

      language.classList.remove("is-open");
      language.setAttribute("aria-hidden", "true");

      languageOpenButtons.forEach((button) => {
        button.setAttribute("aria-expanded", "false");
      });

      unlockPage();
    }

    function openLanguage(event) {
      if (!language) return;

      previousFocus = event?.currentTarget || document.activeElement;

      closeMega();
      closeHelp();
      closeDrawer();
      closeSearch();
      closeCountry();

      language.classList.add("is-open");
      language.setAttribute("aria-hidden", "false");

      languageOpenButtons.forEach((button) => {
        button.setAttribute("aria-expanded", "true");
      });

      lockPage();

      window.setTimeout(() => {
        language.querySelector("[data-kh-language-close]")?.focus();
      }, 120);
    }

    languageOpenButtons.forEach((button) => {
      button.addEventListener("click", openLanguage);
    });

    languageCloseButtons.forEach((button) => {
      button.addEventListener("click", () => {
        closeLanguage();
        previousFocus?.focus?.({ preventScroll: true });
      });
    });

    languageOptions.forEach((button) => {
      button.addEventListener("click", () => {
        const value = button.dataset.khLanguageValue;

        if (!languageInput || !value) return;
        if (languageInput.value === value) {
          closeLanguage();
          return;
        }

        languageInput.value = value;
        languageInput.closest("form")?.submit();
      });
    });

    /* =====================================================
       TOUCHE ÉCHAP
    ====================================================== */

    document.addEventListener("keydown", (event) => {
      if (event.key !== "Escape") return;

      closeMega();
      closeHelp();
      closeDrawer();
      closeSearch();
      closeCountry();
      closeLanguage();
    });

    /* =====================================================
       COMPTEUR PANIER
    ====================================================== */

    const updateCartCount = async () => {
      if (!cartCounter) return;

      try {
        const rootPath =
          window.Shopify?.routes?.root || "/";

        const response = await fetch(
          `${rootPath}cart.js`,
          {
            credentials: "same-origin",
            headers: {
              Accept: "application/json"
            }
          }
        );

        if (!response.ok) return;

        const cart = await response.json();
        const count = Number(cart.item_count || 0);

        cartCounter.textContent =
          count > 99 ? "99+" : String(count);

        cartCounter.classList.toggle(
          "is-empty",
          count === 0
        );
      } catch (error) {
        console.warn(
          "KOLORS : compteur panier indisponible.",
          error
        );
      }
    };

    document.addEventListener(
      "cart:updated",
      updateCartCount
    );

    document.addEventListener(
      "cart:refresh",
      updateCartCount
    );

    document.addEventListener(
      "product:added",
      updateCartCount
    );

    document.addEventListener("click", (event) => {
      const addButton = event.target.closest(
        [
          'button[name="add"]',
          '[type="submit"][name="add"]',
          ".product-form__submit"
        ].join(",")
      );

      if (!addButton) return;

      window.setTimeout(updateCartCount, 450);
      window.setTimeout(updateCartCount, 1100);
    });

    window.addEventListener(
      "pageshow",
      updateCartCount
    );

    document.addEventListener(
      "visibilitychange",
      () => {
        if (document.visibilityState === "visible") {
          updateCartCount();
        }
      }
    );

    updateCartCount();
  };

  const initializeAllHeaders = () => {
    document
      .querySelectorAll("[data-kh-root]")
      .forEach(initializeKolorsHeader);
  };

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initializeAllHeaders
    );
  } else {
    initializeAllHeaders();
  }

  document.addEventListener(
    "shopify:section:load",
    initializeAllHeaders
  );
})();
